import { apolloClient } from "../../vue-apollo";
import {
    GET_ENCUESTAS_PAGINAS,
    GET_ENCUESTAS_PAGINADAS,
    GET_ENCUESTA_ID
} from "../../graphql/queries";
import {
    RESPONDER_ENCUESTA
} from "../../graphql/mutations";

export default {
    namespaced: true,
    state: {
        paginacionTotalEncuestas: [],
        listEncuestasActivas: [],
        encuestaIdAdmin: []
    },
    getters: {
    },
    mutations: {
        
        SET_ENCUESTA_PAGINAS(state, paginas){
            state.paginacionTotalEncuestas = paginas;
        },

        SET_LISTA_ENCUESTAS(state, encuestas){
            state.listEncuestasActivas = encuestas;
        },
        SET_ENCUESTA_ID(state, encuesta){
            state.encuestaIdAdmin = encuesta;
        },
        SET_FALSO(state, carp){
            console.log("", carp);
        }

    },
    actions: {
        async getPaginasEncuestas({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_ENCUESTAS_PAGINAS,
                variables: data_,
                fetchPolicy: 'network-only'
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server paginacionTotalEncuestas: ", res.data.paginacionTotalEncuestas);
                if (!res.loading) response = res.data.paginacionTotalEncuestas;
            });
            }
            catch(e){
            console.log("Falla error, getPaginasEncuestas ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_ENCUESTA_PAGINAS", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
            
            
        },

        async getListaEncuestas({ commit }, data_){
            let response = null;
            let params = {
                query: GET_ENCUESTAS_PAGINADAS,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server listEncuestasActivas: ", res.data.listEncuestasActivas);
                if (!res.loading) response = res.data.listEncuestasActivas;
            });
            }
            catch(e){
            console.log("Falla error, getListaEncuestas ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_LISTA_ENCUESTAS", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
            
        },

        async getEncuestaId({ commit }, data_){
            let response = null;
            let params = {
                query: GET_ENCUESTA_ID,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server encuestaIdAdmin: ", res.data.encuestaIdAdmin);
                if (!res.loading) response = res.data.encuestaIdAdmin;
            });
            }
            catch(e){
            console.log("Falla error, getEncuestaId ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_ENCUESTA_ID", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
            
        },

        async responderEncuesta({ commit }, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: RESPONDER_ENCUESTA,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    //console.log('responderEncuesta', res.data.responderEncuesta);
                    if (!res.loading) data = res.data.responderEncuesta;
                    response = data;
                });
            }
            catch(e){
                console.log("Falla metodo responderEncuesta: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    resolve(response);
                    commit("SET_FALSO", response);
                }
                else {
                resolve(false);
                }
        
            });
        },
    }
};